import axios from 'axios';
import { API_URL } from '@/config';

export default {

  get() {
    return axios.get(`${API_URL}/notifications`);
  },

};
